import React, { memo, useCallback } from "react";

import {
  Button,
  Center,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";
import useDeleteFileMutation from "./networking/use-delete-file";
import { useFragment } from "@apollo/client";
import FILE_FRAGMENT from "modules/messaging/_networking/file-fragment";
import { useOverlay } from "modules/providers/overlay-provider";

interface IProps {
  fileId: string;
  messageThreadId: string;
}

const DeleteFileModal = ({ fileId, messageThreadId }: IProps) => {
  const { closeModal } = useOverlay();
  const [deleteFileMutationAPI] = useDeleteFileMutation(
    fileId,
    messageThreadId,
  );

  const { data: file } = useFragment({
    fragment: FILE_FRAGMENT,
    fragmentName: "File",
    from: {
      __typename: "File",
      id: fileId,
    },
  });

  const onDeleteClicked = useCallback(() => {
    deleteFileMutationAPI();
    closeModal();
  }, [deleteFileMutationAPI, closeModal]);

  return (
    <Modal isOpen onClose={closeModal} size="xs" isCentered>
      <ModalOverlay />
      <ModalContent borderRadius={16}>
        <ModalHeader>
          <Center>
            <Text>Delete File</Text>
          </Center>
        </ModalHeader>
        <ModalBody>
          <VStack>
            <Text fontSize={14} textAlign="center">
              Are you sure you want to delete this file?
              {file.isVoiceNote && (
                <>
                  {" "}
                  Both the voice note and its transcription will be deleted from
                  this conversation.
                </>
              )}
            </Text>
            <HStack>
              <Button variant="cancel" height={8} w={28} onClick={closeModal}>
                No
              </Button>
              <Button height={8} w={28} onClick={onDeleteClicked}>
                Yes
              </Button>
            </HStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default memo(DeleteFileModal);
